import api from "./Api";

class CategoriaOrdemServicoService {
  GetCategoriaOrdemServico(payload) {
    return api.get("/v1/categoriaOrdemServico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCategoriaOrdemServico(payload) {
    return api.post("/v1/categoriaOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  PutCategoriaOrdemServico(payload) {
    return api.put("/v1/categoriaOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCategoriaOrdemServico(payload) {
    return api
      .delete("/v1/categoriaOrdemServico/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetCategoriaOrdemServicoOData(payload) {
    return api
      .get("/OData/CategoriaOrdemServico" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CategoriaOrdemServicoService();
